<template>
    <div class="modal-content m-productPrices">
        <div class="modal-header bg-1">
            <modal-close />
            <div class="modal-title text-center mb-0 mb-md-2">
                <h2 class="h3 mb-1 mt-2">
                    Eksport promocji do pliku
                </h2>
            </div>
        </div>
        <div class="modal-top d-sm-block d-none">
            <div class="a-infoBar a-infoBar--warning text-sm">
                {{ exportConditionsWarningText }}
            </div>
        </div>
        <div class="modal-body p-3 px-sm-4 py-sm-2">
            <div class="a-infoBar a-infoBar--warning text-sm d-sm-none d-block">
                {{ exportConditionsWarningText }}
            </div>
            <div class="row mt-sm-2 mt-3">
                <div class="col-md-4 mb-4">
                    <h5 class="h5 mb-4">Wybierz system:</h5>

                    <div
                        class="form-group"
                        v-for="(fType, fIdx) in fileTypes"
                        :key="fIdx"
                    >
                        <ui-checkbox-input
                            class="custom-control custom-checkbox"
                            :label="fType.label"
                            :name="fType.value"
                            :value="selectedFileType === fType.value"
                            :radio-type="true"
                            @change="onFileTypeChange(fType.value)"
                        />
                    </div>
                    <!-- <h5 class="h5 mb-4 mt-5">Wybierz typ promocji:</h5>

                    <div
                        class="form-group"
                        v-for="(promoType, pIdx) in $store.getters
                            .getPromoTypesForPromoFilters"
                        :key="'pt' + pIdx"
                    >
                        <ui-checkbox-input
                            class="custom-control custom-checkbox"
                            :label="promoType.label"
                            :name="promoType.value"
                            :value="selectedPromoType === promoType.value"
                            :radio-type="true"
                            @change="onPromoTypeChange(promoType.value)"
                        />
                    </div> -->

                    <div class="mt-4">
                        <a
                            @click="
                                $functions.downloadFile(
                                    tutorial.link,
                                    tutorial.name
                                )
                            "
                            download
                        >
                            <the-btn
                                btn-class="btn-secondary btn-sm"
                                text="Pobierz instrukcję"
                                icon="Download"
                                class="px-4 px-lg-5"
                            />
                        </a>
                    </div>
                </div>
                <div class="col-md-8">
                    <h5 class="h5 mb-4">
                        Wybierz sklep, dla którego chcesz wygenerować plik:
                    </h5>
                    <check-list
                        v-if="merchants"
                        class="pb-3"
                        :select-row="selectMerchant"
                        :selected-rows="selectedMerchants"
                        :list="merchants"
                        :row-info="false"
                    />
                </div>
            </div>
            <div
                class="text-sm a-infoBar a-infoBar--warning d-sm-none d-block"
                v-html="warningText"
            ></div>
        </div>
        <div
            class="modal-footer py-1"
            style="position: sticky; bottom: 73px; background: white"
        >
            <div
                class="text-sm a-infoBar a-infoBar--warning d-sm-block d-none"
                v-html="warningText"
            ></div>
        </div>
        <div
            class="modal-footer flex-nowrap"
            style="position: sticky; bottom: 0; background: white; height: 73px"
        >
            <the-btn
                class="btn-outline-custom btn-block my-0"
                text="Zamknij"
                @click.native="$store.dispatch('toggleModal', false)"
            />
            <the-btn
                class="btn-block my-0"
                text="Pobierz"
                icon="Download"
                :loading-status="$store.getters.getExportFileStatus"
                :disabled="!isDownloadButtonAvailable"
                @click.native="exportFiles"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'ModalExportFiles',
    data() {
        return {
            tutorial: {
                name:
                    'Instrukcja wczytywania promocji do programów zapleczowych',
                link:
                    'https://minio.europlatform.pl/ep-prod/publiczne/nazwane/Wczytywanie_promocji_EuroPlatform.pdf'
            }
        }
    },
    computed: {
        modalArgs() {
            return this.$store.getters.modalState.args
        },
        merchants() {
            const merchants = this.$store.getters.getAvailableMerchants
            return merchants.map(merchant => {
                return {
                    id: merchant.id,
                    label: `<h6 class="mb-0">${
                        merchant.name
                    }</h6> <span class="text-sm">${this.setShopAddress(
                        merchant
                    )}</span>`
                }
            })
        },
        selectedMerchants() {
            return this.$store.getters.getSelectedExportFileMerchants
        },
        isDownloadButtonAvailable() {
            return !!this.selectedMerchants?.length
        },
        selectedFileType() {
            return this.$store.getters.getSelectedExportFileType
        },
        selectedPromoType() {
            return this.$store.getters.getSelectedExportFilePromoType
        },
        fileTypes() {
            return this.$store.getters.getExportFileTypes
        },
        exportConditionsWarningText() {
            return 'Wyeksportowane zostaną promocje w mechanizmach Okresowa obniżka ceny, Wagowa okresowa obniżka ceny, Cena regularna oraz Wagowa Cena regularna, które nie posiadają limitu sztuk na paragon oraz nie są w wariancie „Tylko z aplikacją”. Jeśli promocje spełniające wymagania nie są aktywne, wyeksportowany zostanie pusty plik.'
        },
        warningText() {
            return `<div class="text-primary font-weight-bold">UWAGA!</div>
                Przerwanie promocji przez organizatora nie kończy
                automatycznie promocji w systemie zapleczowym. Musisz
                wycofać ją z systemu samodzielnie. Zapoznaj się z instrukcją
                (zielony przycisk powyżej), aby dowiedzieć się jak to zrobić
                w poszczególnych systemach.`
        }
    },
    methods: {
        setShopAddress(data) {
            return this.$store.getters.getShopAddress(data)
        },
        selectMerchants(value) {
            this.$store.dispatch('selectExportFileMerchants', value)
        },
        selectMerchant(merchant) {
            this.$store.dispatch('selectExportFileMerchant', merchant)
        },
        onFileTypeChange(value) {
            this.$store.dispatch('selectExportFileType', value)
        },
        onPromoTypeChange(value) {
            this.$store.dispatch('selectExportFilePromoType', value)
        },
        exportFiles() {
            if (this.isDownloadButtonAvailable) {
                this.$store.dispatch('exportFilesMinio')
            }
        }
    }
}
</script>
